const sales = {
  state: {
    verificationObj: {
      customer: {},
      allowAllStore: false,
      list: [],
      selectedId: [],
    },
  },
  mutations: {
    setVerificationObj(state, val) {
      state.verificationObj = { ...state.verificationObj, ...val }
    },
    resetVerificationObj(state) {
      state.verificationObj = {
        customer: {},
        allowAllStore: false,
        list: [],
        selectedId: [],
      }
    },
  },
  actions: {},
  getters: {
    getVerificationObj(state) {
      return state.verificationObj
    },
  },
}
export default sales
